import { Component, Input, OnInit } from '@angular/core';

import { AttendanceClassItem, AttendanceDateSummary } from '../../../models/attendance-report.model';

@Component({
  selector: 'app-attendance-report-item',
  templateUrl: './attendance-report-item.component.html',
  styleUrls: ['./attendance-report-item.component.scss'],
  standalone: false
})
export class AttendanceReportItemComponent implements OnInit {

    @Input()
    summaryItem: AttendanceDateSummary;

    constructor() { }

    ngOnInit() {
    }

    public attendanceProvided(item: AttendanceClassItem): boolean {
        return item.classAttendance !== null;
    }

}
